import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DlgCouponComponent } from './dlg-coupon';

@Injectable()
export class ShowDlgCouponService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show(): Promise<any> {
        const dialogRef = this._dialog.open(DlgCouponComponent, {
            panelClass: ['--ui'],
            data: {}
        });

        const source = dialogRef.afterClosed();

        return source.toPromise();
    }
}
